<div class="partner-create">
  <div class="partner-create__content">
    <div class="partner-create__layout">
      <div class="partner-create__header">
        <div class="partner-create__heading">
          <h1 class="page-title">Create Partner</h1>
          <p class="page-subtitle">Add a new partner with complete address information.</p>
        </div>
        <div class="partner-create__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="isSaving || partnerForm.invalid" (click)="savePartner()">
            {{ isSaving ? "Creating..." : "Create partner" }}
          </app-button>
        </div>
      </div>

      <app-card>
        <form [formGroup]="partnerForm" class="partner-create__form">
          <div class="partner-create__form-grid">
            <div class="partner-create__form-field">
              <div class="partner-create__form-label-row">
                <label for="name" class="partner-create__form-label">Partner Name</label>
              </div>
              <input
                id="name"
                type="text"
                formControlName="name"
                autocomplete="off"
                class="partner-create__form-input"
                [class.partner-create__form-input--error]="partnerForm.get('name')?.invalid && partnerForm.get('name')?.touched" />
              @if (partnerForm.get('name')?.invalid && partnerForm.get('name')?.touched) {
              <div class="partner-create__form-error">Partner name is required and must be at least 2 characters</div>
              }
            </div>

            <div class="partner-create__form-field">
              <div class="partner-create__form-label-row">
                <label for="type" class="partner-create__form-label">Type</label>
              </div>
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="typeOptions"
                placeholder="Search type..."
                [minLength]="1"
                [debounceMs]="200"
                (selectionChange)="onTypeChange($event)" />
              @if (partnerForm.get('type')?.invalid && partnerForm.get('type')?.touched) {
              <div class="partner-create__form-error">Type is required</div>
              }
            </div>
          </div>
        </form>
      </app-card>

      <app-card class="partner-create__address-card">
        <div class="partner-create__section-header">
          <div>
            <h2 class="partner-create__section-title">Address Information</h2>
            <p class="partner-create__section-hint">Select the location hierarchy and provide address details.</p>
          </div>
        </div>

        <app-location-selector (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
    </div>
  </div>
</div>
